export const UPDATE_TWITTER_HANDLE = 'UPDATE_TWITTER_HANDLE'
export const SEARCH_TWITTER_HANDLE = 'SEARCH_TWITTER_HANDLE'

export const REDUX_STORE_HOME = 'add_twitter_source'
